class OurService {
  constructor() {
    this.init();
  }

  init() {
    this.handleMEWS();
  }

  handleMEWS() {
    const buttonSend = document.querySelector('.our-service_book-room');
    const tokenMews = backendData.tokenSleep

    buttonSend?.addEventListener('click', () => {
      this.openWidget(tokenMews);
    });
  }

  openWidget(token){
    Mews.Distributor(
      {
        configurationIds: [token],
      },
      function (api) {
        const checkInDate = '';
        const checkOutDate = '';
        let date = checkInDate + ' - ' + checkOutDate;
        let startDate = null;
        let endDate = null;
        const dateRangePattern = /^\d{2}\/\d{2}\/\d{4} - \d{2}\/\d{2}\/\d{4}$/;

        if(dateRangePattern.test(date)) {
          let [day, month, year] = date.split(' - ')[0].split("/").map(Number);
          startDate = new Date(year, month - 1, day);
          [day, month, year] = date.split(' - ')[1].split("/").map(Number);
          endDate = new Date(year, month - 1, day);

          api.setStartDate(startDate);
          api.setEndDate(endDate);
          api.showRooms();
        }

        const currentLang = document.querySelector("body").dataset.lang;
        const languageCode = currentLang === 'De' ? 'de-DE' : 'en-US'
        api.setLanguageCode(languageCode);
        api.open();
      }
    );
  }
}

new OurService();